/** i18n menu + trang — merge vào `components.menu` (xem REMOVE.md). */
export const testDataMenuI18n = {
  testData: 'Tạo dữ liệu test',
  testDataPage: {
    title: 'Tạo dữ liệu test',
    description:
      'Mỗi khối tương ứng một cụm module. Trước khi tạo, hệ thống kiểm tra dữ liệu đã có (mã, tên) và chỉ thêm phần còn thiếu — dữ liệu sinh ra giống dữ liệu thật.',
    skipExistingBadge: 'Tự động bỏ qua bản ghi đã tồn tại',
    sectionBundle: 'Tạo nhanh',
    sectionNhomHang: 'Nhóm hàng',
    sectionHangHoa: 'Hàng hóa',
    sectionKho: 'Kho',
    sectionCustomer: 'Khách hàng',
    sectionSupplier: 'Nhà cung cấp',
    btnBundleAll: 'Gói cơ bản ({dm} DM NH + {nkh} DM KH + {ncc} NCC)',
    btnDmNhomHang: 'Danh mục nhóm hàng ({total})',
    btnHangHoa: 'Hàng hóa ({perCat}/DM × {cats} DM lá)',
    btnThuongHieu: 'Thương hiệu ({count})',
    btnDonViTinh: 'Đơn vị tính ({count})',
    btnViTri: 'Vị trí kho ({count})',
    btnDmKhachHang: 'Danh mục KH ({count})',
    btnKhachHang: 'Khách hàng ({per}/danh mục)',
    btnDmNcc: 'Danh mục NCC ({count})',
    btnNcc: 'Nhà cung cấp ({count})',
    seedAll:
      'Bộ cơ bản: {dm} NH cấp 1 + {nkh} nhóm KH + {ncc} NCC',
    seedAllHint: 'Chạy tuần tự 4 bước; bỏ qua mục đã có sẵn.',
    seedNhomHangDanhMuc: 'Nhóm hàng chỉ cấp 1 — {count} danh mục gốc (không con)',
    seedNhomHangTree3: 'Cây nhóm hàng 3 cấp — {total} nhóm ngành hàng',
    seedNhomHangTree3Hint: 'Tên ngành hàng thực tế; chạy lại an toàn.',
    seedSanPham:
      'Hàng hóa theo danh mục — {perCat} SP × {cats} danh mục ({total} sản phẩm)',
    seedSanPhamHint: 'Cần có cây 3 cấp; kiểm tra mã SP trước khi tạo.',
    seedThuongHieu: 'Thương hiệu — {count} TH (tên phổ biến)',
    seedDonViTinh: 'Đơn vị tính — {count} ĐVT (phổ biến bán lẻ)',
    seedViTri: 'Vị trí kho — {count} vị trí (10 khu × 10 kệ)',
    seedViTriHint: 'Mã VT-A01 … VT-J10.',
    seedNhomHangTree:
      'Nhóm hàng cây 4 cấp — dữ liệu lớn ({total} nhóm, chạy lâu)',
    seedNhomKhachHang: 'Nhóm khách hàng — {count} nhóm (phân khúc)',
    seedNhomKhachHangHint: 'Tạo nhóm trước khi sinh khách hàng.',
    seedKhachHang:
      'Khách hàng theo nhóm — {perGroup} KH × {groups} nhóm ({total} khách hàng)',
    seedKhachHangHint: 'Tên, SĐT, email giống dữ liệu thật; gắn đúng nhóm.',
    seedNhaCungCap:
      'Nhà cung cấp — {total} NCC (tên công ty & mã thực tế)',
    seedNhaCungCapHint: 'Tên công ty & mã NCC thực tế.',
    progress: '{done} / {total}',
    logTitle: 'Kết quả',
    success: 'Hoàn tất — xem log chi tiết bên dưới',
    failed: 'Tạo dữ liệu test thất bại',
    partialSuccess: 'Một phần thao tác thất bại — xem log bên dưới',
  },
} as const
